import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';

type GetZendeskInformationResponse = {
  ticketId: string;
};

const getZendeskInformationAsync = ({ folderId }: { folderId: string }) =>
  axios.get<GetZendeskInformationResponse>(`/folders/${folderId}/zendesk-informations`);

export const useGetZendeskInformationAsync = (
  { folderId }: { folderId: string },
  { isEnabled }: { isEnabled: boolean } = { isEnabled: true },
) =>
  useQuery({
    retry: 3,
    enabled: isEnabled,
    queryKey: ['zendesk-information', folderId],
    queryFn: async () => {
      const { data } = await getZendeskInformationAsync({ folderId });
      return data;
    },
  });
